import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

export const SelectFieldRoot = styled(FormControl)({
  position: 'relative',
});

export const SelectFieldField = styled(Select)(({ clearable }: { clearable?: boolean }) => {
  if (!clearable) {
    return;
  }

  return {
    position: 'absolute',
    bottom: 1,
    right: 24,
  };
});

export const SelectFieldResetIcon = styled('div')({
  position: 'absolute',
  bottom: 1,
  right: 24,
});
